import { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { MentiSessionProvider } from '../context/MentiSessionContext';
import MentiJoinScreen from '../components/menti/participant/MentiJoinScreen';
import MentiResponseView from '../components/menti/participant/MentiResponseView';

const STORAGE_KEY_PREFIX = 'menti_participant_';

export default function MentiParticipantPage() {
  const { sessionId: urlSessionId } = useParams();
  const [searchParams] = useSearchParams();
  const prefilledPin = urlSessionId || searchParams.get('session') || searchParams.get('pin') || '';
  const [joined, setJoined] = useState(false);
  const [sessionId, setSessionId] = useState(prefilledPin);
  const [participantId, setParticipantId] = useState('');
  const [recovering, setRecovering] = useState(true);

  // Recover from localStorage on mount
  useEffect(() => {
    try {
      const key = prefilledPin ? `${STORAGE_KEY_PREFIX}${prefilledPin}` : null;
      if (key) {
        const saved = localStorage.getItem(key);
        if (saved) {
          const { sessionId: sid, participantId: pid } = JSON.parse(saved);
          if (sid && pid) {
            setSessionId(sid);
            setParticipantId(pid);
            setJoined(true);
          }
        }
      } else {
        for (let i = 0; i < localStorage.length; i++) {
          const k = localStorage.key(i);
          if (k && k.startsWith(STORAGE_KEY_PREFIX)) {
            const saved = JSON.parse(localStorage.getItem(k));
            if (saved?.sessionId && saved?.participantId) {
              setSessionId(saved.sessionId);
              setParticipantId(saved.participantId);
              setJoined(true);
              break;
            }
          }
        }
      }
    } catch {
      // Ignore localStorage errors
    }
    setRecovering(false);
  }, [prefilledPin]);

  const handleJoin = ({ sessionId: sid, participantId: pid }) => {
    setSessionId(sid);
    setParticipantId(pid);
    setJoined(true);
    try {
      localStorage.setItem(`${STORAGE_KEY_PREFIX}${sid}`, JSON.stringify({ sessionId: sid, participantId: pid }));
    } catch {
      // Ignore
    }
  };

  const handleLeave = () => {
    try {
      localStorage.removeItem(`${STORAGE_KEY_PREFIX}${sessionId}`);
    } catch {
      // Ignore
    }
    setJoined(false);
    setParticipantId('');
  };

  if (recovering) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center font-display">
        <span className="material-symbols-outlined text-5xl text-blue-500 animate-spin mb-4">progress_activity</span>
        <p className="text-gray-600 font-semibold">Lastar...</p>
      </div>
    );
  }

  if (!joined) {
    return <MentiJoinScreen onJoin={handleJoin} prefilledPin={prefilledPin} />;
  }

  return (
    <MentiSessionProvider sessionId={sessionId}>
      <MentiResponseView
        sessionId={sessionId}
        participantId={participantId}
        onLeave={handleLeave}
      />
    </MentiSessionProvider>
  );
}
